import { experiments } from '../../experiments';

interface UseExperimentsResult {
  uiForNewResponseStructure: boolean;
}
export const useNewUiExperiment = (): UseExperimentsResult => {
  const uiForNewResponseStructure = experiments.is(
    'specs.chatbot.enableNewAnswerGenerationStructure',
    'true',
  );
  return {
    uiForNewResponseStructure,
  };
};
